import script from "./SelectOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectOption.vue?vue&type=script&setup=true&lang=ts"

import "./SelectOption.vue?vue&type=style&index=0&id=b58211de&lang=scss&scoped=true"
import "./SelectOption.vue?vue&type=style&index=1&id=b58211de&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b58211de"]])

export default __exports__